import { render, staticRenderFns } from "./addBomToTask.vue?vue&type=template&id=1405921c&scoped=true&"
import script from "./addBomToTask.vue?vue&type=script&lang=js&"
export * from "./addBomToTask.vue?vue&type=script&lang=js&"
import style0 from "./addBomToTask.vue?vue&type=style&index=0&id=1405921c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1405921c",
  null
  
)

export default component.exports